import moment from "moment";

export function twoDatesRelative(start_time, end_time, base_time) {
    var start_moment = moment(start_time);
    var end_moment = moment(end_time);
    var base_moment = moment(base_time);


    if (start_moment.isSame(end_moment, 'day')) {
        if (end_moment.isSame(base_moment, 'year')) {
            return start_moment.format('ddd Do MMM');
        }
        else {
            return start_moment.format('ddd Do MMM YYYY');
        }
    }
    else if (start_moment.isSame(end_moment, 'month')) {

        if (end_moment.isSame(base_moment, 'year')) {
            return start_moment.format('ddd Do') + ' - ' + end_moment.format('ddd Do MMM');
        }
        else {
            return start_moment.format('ddd Do') + ' - ' + end_moment.format('ddd Do MMM YYYY');
        }
    }
    else {
        if (end_moment.isSame(base_moment, 'year')) {
            return start_moment.format('ddd Do MMM') + ' - ' + end_moment.format('ddd Do MMM');
        }
        else {
            return start_moment.format('ddd Do MMM') + ' - ' + end_moment.format('ddd Do MMM YYYY');
        }
    }
}

export function getNamingConventions(device_name) {
    var [header, subheader, triheader] = [device_name, undefined, undefined];
    const dividers = ["_", " opp ", " at ", " @ ", " before ", " after ", " near ", ",", " ("];

    for (var divider of dividers) {
        if (device_name.includes(divider)) {
            [header, subheader, triheader] = device_name.split(divider).map((el) => el.trim());
            subheader = (divider.substring(1) + subheader).trim();
            return [header, subheader, triheader];
        }
    }

    return [header, subheader, triheader];
}